import React, {useState} from 'react';
import OpsText from "../../ops-library/ops-text";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import opsToast from "../../ops-library/ops-toast";
import OpsInput from "../../ops-library/ops-input";
import OpsBtn from "../../ops-library/ops-btn";
import {LoadingSpinner} from "../LoadingSpinner";

const ConcertPreview = ({concert, action, className = "prew-concert-intro-container"}) => {
    const navigate = useNavigate()
    const date = new Date(concert?.dateTime);
    const day = date.getUTCDate();
    const month = date.toLocaleDateString("sk-SK", {month: "long"});
    const time = date.toLocaleTimeString("sk-SK", {hour: "2-digit", minute: "2-digit"});
    const description = !concert?.private ? `${time} ${concert?.description}` : concert?.description


    return (
        <div className={`fa-flex-row gap-3 pointer-cursor ${className}`}
             onClick={action}>
            <div className="prew-concert-date fa-flex-col bg-3 justify-content-center">
                <OpsText type="title7 mb-neg" weight={900} color="color-2"
                         content={day}/>
                <OpsText type="normal" weight={400} color="color-2"
                         content={month}/>
            </div>
            <div className="prew-concert-text fa-flex-col justify-content-center gap-2">
                <OpsText type="title1 mb-neg" weight={800} color="color-1" alignment="left"
                         content={concert?.city?.toUpperCase()}/>
                <OpsText type="normal4" weight={300} color="color-1" alignment="left"
                         content={description}/>
            </div>
        </div>
    );
};

export default ConcertPreview;